import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';

const Tile = (_param)=> {
    var { className , day , month , loading , available , closed , selected , disabled  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "day",
        "month",
        "loading",
        "available",
        "closed",
        "selected",
        "disabled"
    ]);
    return React.createElement("button", swcHelpers.extends({}, rest, {
        type: "button",
        className: classnames('availability-calendar-tile', {
            'availability-calendar-tile--loading': loading,
            'availability-calendar-tile--available': available,
            'availability-calendar-tile--closed': closed,
            'availability-calendar-tile--selected': selected
        }, className),
        disabled: loading || disabled
    }), /*#__PURE__*/ React.createElement("span", {
        className: "availability-calendar-tile__day"
    }, day), month && /*#__PURE__*/ React.createElement("span", {
        className: "availability-calendar-tile__month"
    }, "\xa0", month, "\xa0"), /*#__PURE__*/ React.createElement("span", {
        className: "availability-calendar-tile__availability",
        "aria-hidden": true
    }, /*#__PURE__*/ React.createElement("span", {
        className: "availability-calendar-tile__availability-dot"
    })), /*#__PURE__*/ React.createElement("span", {
        className: "availability-calendar-tile__cross",
        "aria-hidden": true
    }));
};

export { Tile as default };
//# sourceMappingURL=Tile.js.map
